import { ErrorState } from '@/ui/ErrorState';

import type { DefinicaoDoCadastro } from './cadastros.definicoes';

/**
 * Endereço de criar ou de editar escola. As duas rotas continuam no mapa de
 * navegação, mas o cadastro de escolas vem do EOL e não se altera por aqui: em
 * vez de um formulário que não grava, a tela diz isso e leva de volta à lista.
 */
export function EscolaSomenteConsulta({ definicao }: { definicao: DefinicaoDoCadastro }) {
  return (
    <ErrorState
      variant="resource-not-found"
      title="O cadastro de escolas vem do EOL"
      description="Escola não se cria nem se altera por esta tela. Consulte a lista para ver o que o EOL trouxe."
      primaryAction={{ label: definicao.titulo, to: definicao.caminho }}
    />
  );
}
